export const localeListInverted = {
  en: 'en-US',
};

export default {
  'en-US': 'en',
};

export const findLocaleNodes = (nodes, locale) => {
  const result = nodes.find(
    (node) => node?.node_locale === (localeListInverted[locale] || locale)
  );

  if (result === null && locale === 'ro') {
    return nodes.find((node) => node?.node_locale === 'en-US');
  }

  return result;
};

export const filterLocaleNodes = (nodes, locale) => {
  return nodes.filter(
    (node) => node?.node_locale === (localeListInverted[locale] || locale)
  );
};

export const filterLocaleNodesSubjects = (nodes, locale) => {
  return nodes.filter((node) => {
    return (
      node?.node_locale === (localeListInverted[locale] || locale) &&
      node.activeOn.some((domain) =>
        domain.includes(`.${process.env.GATSBY_DEFAULT_LANGUAGE}`)
      )
    );
  });
};
